<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">회원관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">사업자회원</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="일반회원">일반회원</router-link></li>
            <li><router-link to="/businessmembership" title="사업자회원">사업자회원</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">사업자 회원</h3>
        <article>
          <div class="searchArea">
            <div class="total">
              총<span>{{ memberCnt }}</span
              >건
            </div>
            <div class="searchBox">
              <div>
                <select id="" v-model="searchCondition" title="검색영역 선택">
                  <option value="1">아이디</option>
                  <option value="4">법인(단체)명</option>
                  <option value="2">대표자명</option>
                  <option value="5">사업자등록번호</option>
                </select>
                <input
                  type="text"
                  title="검색어 입력"
                  placeholder="검색어입력"
                  v-model="searchKeyword"
                  @keyup.enter="searchBusinessMember"/>
              </div>
              <button type="button" class="btn dkGray" @click="searchBusinessMember">검색</button>
            </div>
          </div>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  사업자회원 테이블
                </caption>
                <thead>
                  <tr>
                    <th scope="col">번호</th>
                    <th scope="col">아이디</th>
                    <th scope="col">법인(단체)명</th>
                    <th scope="col">대표자명</th>
                    <th scope="col">사업자등록번호</th>
                    <th scope="col">가입신청일</th>
                    <th scope="col">가입승인일</th>
                    <th scope="col">웹 선불권 신청주차장</th>
                    <th scope="col">상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="nodate" v-if="nodata">
                    <td colspan="9">조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-else v-for="(item, index) in calData" :key="index" @click="view(item.empEsntlId)">
                    <td>{{ ( listData.length - index ) - ( (curPageNum-1) * dataPerPage ) }}</td>
                    <td>{{ item.empNo }}</td>
                    <td>{{ item.companyNm }}</td>
                    <td>{{ item.empNm }}</td>
                    <td>{{ item.companyNo }}</td>
                    <td>{{ item.regDttm | ptDateFormat }}</td>
                    <td>{{ item.updDttm | ptDateFormat }}</td>
                    <td>{{ item.parkingNms }}</td>
                    <td v-if="item.empSttus === 'A'">신청</td>
                    <td v-else-if="item.empSttus === 'D'">삭제</td>
                    <td v-else-if="item.empSttus === 'P'">승인</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <v-pagination v-model="curPageNum" :length="numOfPages"></v-pagination>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import moment from 'moment';

export default {
  data() {
    return {
      curPageNum: 1,
      dataPerPage: 10,
      searchCondition: 1,
      searchKeyword: '',
      nodata: true,
      listData: [],
      allChecked: false,
      checkedValues: [],
      memberCnt: 0,
    };
  },

  mounted() {
    this.searchBusinessMember();
  },

  methods: {
    checkboxCkc() {
      if (this.listData.length === this.checkedValues.length) {
        this.allChecked = true;
        return;
      }
      this.allChecked = false;
    },

    stopPropagation(e) {
      e.stopPropagation();
    },

    checkedAll() {
      if (!this.allChecked) {
        this.checkedValues = [];

        this.listData.forEach(element => {
          this.checkedValues.push(
            element.empEsntlId + ';' + element.empNo + ';' + element.empNm + ';' + element.regDttm,
          );
        });
      } else {
        this.checkedValues = [];
      }
    },

    existCheckBox() {
      if (this.checkedValues.length < 1) {
        alert('선택된 체크박스가 없습니다.');
        return false;
      } else {
        return true;
      }
    },

    timestamp: function (regDttm) {
      return moment(regDttm).format('YYYY-MM-DD');
    },

    timestamp: function (updDttm) {
      return moment(updDttm).format('YYYY-MM-DD');
    },

    async searchBusinessMember() {
      const res = await axios('get', '/api/member/list.json', {
        searchCondition: this.searchCondition,
        searchKeyword: this.searchKeyword,
        empCd: 'BSN',
      });
      const data = res.data.resultList;
      if (!data || data.length <= 0) {
        this.listData = [];
        this.nodata = true;
        this.memberCnt = 0;
        return;
      }
      this.listData = data;
      this.nodata = false;
      this.memberCnt = this.listData.length;

      this.curPageNum = 1;
    },

    view(empNo) {
      this.$router.push({
        path: 'businessMembershipView',
        query: { id: empNo },
      });
    },
  },

  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    calData() {
      if (this.listData.length < 0) {
        return;
      }
      return this.listData.slice(this.startOffset, this.endOffset);
    },
  },
};
</script>
